<template>
  <div class="form-container">
    <div class="mb-5 text-center px-5 form-heading">Get in touch with us to discuss your quote by <a href="tel:0330 0945876">giving us a call</a> or filling out the form below.
    </div>
    <form :id="`form-${ calculatorName }`" method="POST" @submit="submitForm" @keyup="clearErrorMessages" @change="clearErrorMessages">
      <div class="row">

        <!-- <pre>{{ calculatorData }}</pre> -->

        <div class="col-12 mb-3">
          <label for="name">Name*</label>
          <input class="form-control" type="text" id="name" name="name" v-model="form.name" required>

          <label for="email">Email*</label>
          <input class="form-control" type="email" id="email" name="email" v-model="form.email" required>

          <label for="phone">Telephone*</label>
          <input class="form-control" type="tel" id="phone" name="phone" v-model="form.phone" required>
        </div>
        <div class="col-12 mb-3">
          <label for="msg">Optional Message</label>
          <textarea id="msg" rows="6" class="form-control" name="msg" v-model="form.msg"></textarea>
        </div>
        <div class="col-12 mb-3">
          <div class="row align-items-center consent-wrapper">
            <div class="consent-checkbox">
              <input type="checkbox" id="privacy" name="privacy" v-model="form.consent" required >
            </div>
            <div class="consent-label">
              <label for="privacy">I consent to my personal information being processed in accordance with Just Mortgage Brokers <a href="/privacy-policy/" target="_blank">Privacy Policy</a></label>
            </div>
          </div>
        </div>
        <div class="col-12 text-center mt-3 mb-3"><button type="submit" class="btn calc-btn-secondary">Start your journey</button></div>
      </div>
    </form>

    <div class="disclaimer">
      *We need to gather more information from you to be sure on your mortgage loan amount. This number is a prediction based off your questionnaire results and isn’t guaranteed.
    </div>

    <div class="form-errors" v-if="formErrors.length > 0">
      <div class="alert alert-danger text-center" role="alert" v-for="(error,i) in formErrors" :key="i">
        {{ error }}
      </div>
    </div>

    <!-- <div class="alert alert-primary bg-green-pale text-center" v-if="submission.submitted && submission.is_valid" v-html="submission.confirmation_message">
        {{submission.confirmation_message}}
    </div>
    <div class="alert alert-danger text-center" role="alert" v-if="submission.submitted && submission.is_valid === false" v-html="validationMessages(submission.validation_messages)">
        {{submission.confirmation_message}}
    </div>                -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    calculatorName: String,
    calculatorData: Object
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        msg: '',
        consent: false
      },
      submission: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
    }
  },
  methods: {
    validationMessages(response) {
      const errorMessage = response;
      // console.log(errorMessage)
      if (errorMessage) { return errorMessage["2"] } return
    },
    submitForm(e) {
      e.preventDefault();

      if (!this.form.name) {
        this.formErrors.push("Please enter your first and last name.");
      }
      if (!this.form.email) {
        this.formErrors.push("Please enter your email address.");
      }
      if (!this.form.phone) {
        this.formErrors.push("Please enter your phone number.");
      }
      if (!this.form.consent) {
        this.formErrors.push("Please agree to our Privacy, Security and Cookie Policy to allow our friendly staff contacting you.");
      }

      let messageBody = {
        input_1: this.form.name,
        input_2: this.form.email,
        input_3: this.form.phone,
        input_4: this.form.msg,
        input_9_1: this.form.consent ? 'Yes' : 'No',
        input_6: this.calculatorData.calculatorTitle,
        input_8: this.calculatorData.calculatorResults
      }

      this.postSubmission(messageBody);
    },
    async postSubmission(submissionData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/2/submissions', submissionData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submission = response;
        const calculatorName = "#form-" + this.calculatorName;

        this.submission.is_valid = submission.is_valid;
        this.submission.confirmation_message = submission.confirmation_message;
        this.submission.validation_messages = submission.validation_messages;

        // Mouseflow JavaScript submission https://help.mouseflow.com/en/articles/4274450-forms-with-no-successful-submits
        window._mfq = window._mfq || [];
        window._mfq.push(["formSubmitAttempt", calculatorName]);
        if (!this.submission.is_valid) {
          window._mfq.push(["formSubmitFailure", calculatorName]);
        } else {
          window._mfq.push(["formSubmitSuccess", calculatorName]);
        }

        this.resetForm();
        const form_res = (await response).data;
        if(form_res.is_valid){
          location.href = form_res.confirmation_redirect;
        }
        

      } catch(error) {
        console.log(error)
      }
    },
    resetForm() {
      this.form = {
        name: '',
        email: '',
        phone: '',
        msg: '',
        consent: false
      }
    },
    clearErrorMessages() {
      this.formErrors = []
    }
  },
  computed: {
    formatedName() {
      let string = this.calculatorName.replace( "calculator", '' ).replace( /-/g, ' ' ).trim()

      const formattedString = (phrase) => {
        return phrase
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
      };

      return formattedString( string )
    }
  }
}
</script>
<style lang="scss">
  .form-container{
    .form-heading{
      color: #323C43;
      text-align: center;
      font-family: "Open Sans";
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 29.25px;
      a{
        color: #EE770E;
        font-family: "Open Sans";
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 29.25px;
        text-decoration: underline;
      }
    }
    .disclaimer{
      color: #A9A9A9;
      font-family: "Open Sans";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .consent-wrapper{
        flex-wrap: nowrap !important;
        .consent-checkbox{
            max-width: fit-content;
        }
        .consent-label{
            max-width: fit-content;
            text-wrap: wrap;
            max-width: 90%;
            label{
                font-size: 14px;
                font-weight: 400;
            }
        }
    }
    .btn{
      width: 100%;
      background-color: #70A64D;
      color: #fff;
      color: var(--White, #FFF);
      text-align: center;
      font-family: "Open Sans";
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 29.25px; /* 208.929% */
      padding: 15px 10px;
      border-radius: 10px;
      &:hover{
        background-color: #EE770E;
        border: none;
        color: #fff;
        border: 1px solid #ee770e;
      }
    }
}
</style>